import React from 'react'
import ModernBankingHero from './ModernBankingHero'
import CallToAction from '../../../../LandingSection/CallToAction'
import Footer from '../../../../Components/Footer'
import Header from '../../../../Components/Header'
import TechStack from './TechStack'
import BusinessNeeds from './BusinessNeeds'
import Solutions from './Solutions'

const ModernBankingCaseStudyPage = () => {
  return (
    <>
      <Header bgColor="#242424"/>
      <div className="overflow-x-hidden w-full">
      <ModernBankingHero />
      <TechStack />
      <BusinessNeeds />
      <Solutions />
      <CallToAction/>
              <Footer/>
      </div>
    </>
  )
}

export default ModernBankingCaseStudyPage
